<template>
  <div>
    <router-view />
    <AppFooter class="p-2" style="position: fixed; bottom: 0%; width: 100%" />
    <responsive-alert />
  </div>
</template>
<script>
import AppFooter from "@/@core/layouts/components/AppFooter.vue";
import ResponsiveAlert from "./components/ResponsiveAlert.vue";
export default {
  components: {
    AppFooter,
    ResponsiveAlert,
  },
};
</script>
